module.exports = __webpack_public_path__ + "static/media/PA-Icon-Telefon-neg.c32f9c95.svg";